import React from 'react';
import util from 'utils/utils';
import { Trans } from 'react-i18next';

export default function IdeaVotedContent({ events, ownerIdea = { name: 'Unknown idea' } }) {
  const textSuffix = events[0]?.isFollower ? 'an idea you follow' : 'your idea';
  return (
    <Trans i18nKey="notifications.ideaVoted">
      <b>{{ name: util.getEventUsers(events) }}</b> liked {{ suffix: textSuffix }} <b> {{ idea: ownerIdea.name }}</b>
    </Trans >
  );
}
